import { render } from "./quillVideoSelectModal.vue?vue&type=template&id=6c8cc92a&scoped=true"
import script from "./quillVideoSelectModal.vue?vue&type=script&lang=js"
export * from "./quillVideoSelectModal.vue?vue&type=script&lang=js"

import "./quillVideoSelectModal.vue?vue&type=style&index=0&id=6c8cc92a&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8cc92a"]])

export default __exports__